export const STEP_NAMES = [
  "LOAD_CONFIG",
  "CREATE_REMOTE_FOLDER",
  "START_ENGINE",
  "OPEN_SITE",
  "GUEST_LOGIN",
  "OPEN_ADVANCED_SEARCH",
  "SELECT_DOCUMENT_TYPES",
  "SET_DATE_RANGE",
  "SUBMIT_SEARCH",
  "PARSE_RESULTS",
  "OPEN_DOCUMENT",
  "REQUEST_PDF",
  "WAIT_FOR_DOWNLOAD",
  "VALIDATE_PDF",
  "STAGE_PDF",
  "UPLOAD",
  "VERIFY_UPLOAD",
  "WRITE_MANIFEST",
  "CAPTURE_EXCEPTION_BUNDLE",
  "CLEANUP"
] as const;

export type StepName = (typeof STEP_NAMES)[number];

export function isStepName(value: string): value is StepName {
  return STEP_NAMES.includes(value as StepName);
}
